import { render, staticRenderFns } from "./LoginSideMenu.vue?vue&type=template&id=d44373f6"
import script from "./LoginSideMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginSideMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoginSideMenu.vue?vue&type=style&index=0&id=d44373f6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports